import { defineStore } from 'pinia'
import type ITeam from '~/types/Storyblok/Vacancy/Team'
import { useFetchTeamData } from '~/composables/useFetchTeamData'

export const useTeamsStore = defineStore('teams', {
  state: (): {
    teams: ITeam[]
    activeTeam: string
  } => ({
    teams: [],
    activeTeam: ''
  }),
  actions: {
    async fetchTeams(locale: string) {
      const { fetchTeamsData } = useFetchTeamData()

      const cmsTeams = await fetchTeamsData(locale)

      const teams: ITeam[] = []

      cmsTeams.forEach((team: ITeam) => {
        teams.push({ ...team, count: 0 })
      })

      this.teams = teams
    },

    fetchVacancyCount(locale: string) {
      const { fetchTeamVacancyCount } = useFetchTeamData()

      const promises = this.teams.map((team, i) =>
        fetchTeamVacancyCount(locale, team.code).then((count) => {
          this.teams[i].count = count
        })
      )

      Promise.all(promises)
    }
  }
})
